import {_, lockr, React, ReactDOM, Sentry, uiConstants, observer} from '@api'
import {ApolloProvider, BrowserRouter} from '@apollo'
import {ErrorContainer} from '@design-board/components'
import {MuiThemeProvider} from '@material-ui/core/styles'
import {Severity} from '@sentry/types'
import * as SentryTracing from '@sentry/tracing'
import {NetworkStatusNotifier, deployments, globalStores as stores} from '@stores'
import {buildErrorMessage} from '@utils/errorUtils'
import {MainTheme} from 'centric-ui-components'
// import 'typeface-roboto'
import {toJS, when, autorun, runInAction} from 'mobx'
import {QueryClient, QueryClientProvider} from 'react-query'
import {AppWithSentryProfiler, VIP_MerchBoard_App} from './App'
import {unregister} from './registerServiceWorker'
import {matchPath} from 'react-router-dom'
import './styles/main.css'

// window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
//   console.log(errorMsg, url, lineNumber);
//   debugger
//   return false;
// }

const queryClient = new QueryClient()

window.addEventListener('error', function (e) {
  if (
    // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    // https://github.com/souporserious/react-measure/issues/104
    e.message == 'ResizeObserver loop limit exceeded'

    // Happens when the PDF stream is aborted early (like changing seasons or groups while the PDF is rendering)
    //https://github.com/diegomura/react-pdf/issues/420
    || e.message == 'Uncaught Error: stream.push() after EOF'
    // Happens during logout
    || e.message == 'Uncaught (in promise) Error: GraphQL error: Not authenticated') {
    e.preventDefault()
  } else {
    //debugger
  }
})

/*window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
  console.log(errorMsg, url, lineNumber);
  return false;
}*/

const routes = [
  {path: '/'},
  {path: '/login'},
  {path: '/logout'},
  {path: '/dashboard'}
]

setTimeout(() => {
  autorun(() => {
    if (deployments?.deploymentConfig != null) {
      runInAction(() => {

        const {deploymentConfig: {title, version}} = deployments, {nav: {history}} = stores

        if (false && !DEBUG) {
          Sentry.init({
            dsn: 'https://513f4b27e70f4800bc4d1e01b78e359a@sentry.io/1781833',
            //debug: DEBUG,
            environment: DEBUG ? `${BUILD_USER}-${window.location.host}-${GIT_BRANCH}` : window.location.host,
            release: `${title}@${version}`,
            ignoreErrors: ['ResizeObserver loop limit exceeded', 't.setTraceUpdatesEnabled is not a function', 'evaluating \'__WEBPACK_IMPORTED_MODULE', `WHEN_TIMEOUT`, `GraphQL error: Not authenticated`],
            denyUrls: [
              /extensions\//i,
              /^chrome:\/\//i
            ],
            integrations: [
              new SentryTracing.Integrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history, routes, matchPath)
              })
            ].filter(_.identity),
            tracesSampleRate: DEBUG ? 1.0 : .2 // https://docs.sentry.io/platforms/javascript/guides/react/performance/
            // beforeSend(event, hint) {
            //   event.extra.stores = toJS(_.omit(stores, ['apollo']))
            //   return event
            // }
          })

          DEBUG && Sentry.setUser({username: BUILD_USER})
        }
      })
    }
  }, {name: `Register the application with Sentry.IO once we have our deployment configuration`})
}, 10)

const IGNORE = ['syncMerchCollectionES', 'syncBusinessObject']

const ObservableAppContainer = observer(function ObservableAppContainer() {
  return (
    //<StrictMode>
    // <Profiler id='concept-board'>
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={stores.apollo.client}>
        <MuiThemeProvider theme={MainTheme}>
          <NetworkStatusNotifier render={({loading, error, numPendingRequests}) => {
            if (error) {
              const {graphQLErrors, operation: {operationName}} = error, {nav, auth} = stores
              if (IGNORE.includes(operationName)) { return null }
              if (_.isArray(graphQLErrors) && _.every(graphQLErrors, e => e.message == 'Not authenticated') && nav.location.pathname != 'logout') {
                console.log('Authentication Error - Redirecting to Login Page', error)
                // Redirect to login
                setTimeout(() => {
                  stores.auth.invalidateUser()
                  stores.nav.routeToLoginPage()
                }, 0)
                return null
              }
            }
            const errorMessage = buildErrorMessage(error)
            !loading && error && Sentry.captureEvent({level: Severity.Error, fingerprint: ['graphql'], message: errorMessage, extra: {error}})

            return (
              error && <ErrorContainer error={errorMessage}/>
            )
          }}
          />
          <BrowserRouter>
            <VIP_MerchBoard_App/>
          </BrowserRouter>
        </MuiThemeProvider>
      </ApolloProvider>
    </QueryClientProvider>
    // </Profiler>
    //</StrictMode>
  )
})

//ReactDOM.unstable_createRoot(document.getElementById('root')).render(<ObservableAppContainer/>)
ReactDOM.render(<ObservableAppContainer/>, document.getElementById('root'))

unregister()

export {VIP_MerchBoard_App} from './App'


// WEBPACK FOOTER //
// ./src/index.tsx